export function getBusiness() {
  return [
    { abbr: "GS", name: "Group Services"},
    { abbr: "CON", name: "Construction Group"},
    { abbr: "RES", name: "Residential"},
    { abbr: "PS", name: "Property Services"},
  ]
};
